import { ENV_CONFIGS } from '../consts';

export default (env, region, key) => {
  if (ENV_CONFIGS[region] && ENV_CONFIGS[region][env] && ENV_CONFIGS[region][env][key]) {
    return ENV_CONFIGS[region][env][key];
  } else {
    throw new Error(`Cannot find env config for env: ${env}, region: ${region} and key: ${key}`);
  }
};
